import React, { Component } from 'react'
import CModalNoFooter from 'app/components/normal/CModalNoFooter'
import { Spin } from 'antd'

export default class DownloadingModal extends Component {
  render() {
    const { visible, text } = this.props

    return (
      <CModalNoFooter
        className="download-modal"
        width={230}
        visible={visible}
      >
        <div className="download-loading"><Spin size="large" /></div>
        <div className="download-tips">{text}</div>
      </CModalNoFooter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/DownloadingModal.js